import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../../shared/my-constants';
import {Observable} from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {tap} from 'rxjs/operators';

@Injectable()
export class LabOrderListService {
    private headers = new Headers({'Content-Type': 'application/json'});
    private AddRecord = webapi + 'tpath_bs/create';
    private EditTest = webapi + 'tpath_bs/update';
    private EditTestStatus = webapi + 'tpath_bs/updateteststatus';
    private GetRecord = webapi + 'tpath_bs/byid/';
    private DeleteRecord = webapi + 'tpath_bs/delete/';
    /* Owername :Vijay Patil
      Date : 1-1-2018  */
    private listAllnew = webapi + 'tpath_bs/lol_listnew/';
    private listTestOrder = webapi + 'tpath_bs/test_order_list/?';
    private listTestOrderByBillId = webapi + 'tpath_bs/test_order_list_by_bill_id/?';
    private listTestSamples = webapi + 'tpath_bs/test_samples_list/?';
    private addCollectedSampleurl = webapi + 'tpath_bs/addcollectedsample/?';
    private addCollectedSampleurl_sspm = webapi + 'tpath_bs/addcollectedsample_sspm/?';
    private addTestAcceptanceUrl = webapi + 'tpath_bs/addtestacceptance/?';
    private addAcceptedSampleurl = webapi + 'tpath_bs/addacceptedsample/?';
    private AddacceptedsampleList = webapi + 'tpath_bs/addacceptedsampleList/?';
    private addRejectedSampleurl = webapi + 'tpath_bs/addrejectedsample/?';
    private addResultEntryurl = webapi + 'tpath_bs/addresultentrysample/?';
    private ListRecordByUnitId = webapi + 'mst_staff/listbyunitid/?';
    // private ListRecordByIpdChargeId = webapi + 'tpath_bs/listbyipdchargeid/?';
    private getStaffIdByUserId = webapi + 'tpath_bs/staffbyuserId/?';
    private addLabOrderAcceptanceurl = webapi + 'tpath_bs/laborderacceptance/?';
    private listReportedTestBypsId = webapi + 'mpath_test_result/gettridbypsid/?';
    private GetTestReportParam = webapi + 'mpath_result/listofpathreport/?';
    private testIdByMbillServiceId = webapi + 'mpath_test/findtestid/';
    private listParamByTestId = webapi + 'tpath_bs/lol_test_parameters_list/?';
    private deleteTestReportByTrIdUrl = webapi + 'mpath_test_result/delete/';
    private reduceItemQtyUrl = webapi + 'tpath_bs/reduceitemqty/?';
    private searchItemByTestId = webapi + 'mpath_item_consume/findobiidbytestid/';
    private searchTestIdByServiceId = webapi + 'mpath_test/findtestid/';
    private addUploadReporturl = webapi + 'tpath_bs/adduploadreport/';
    private smsOnSampleColletionUrl = webapi + 'tpath_bs/smsonsamplecollection/';
    private smsOnReportFinalizedUrl = webapi + 'tpath_bs/smsonreportfinalized/';
    private testResulReportUpload = webapi + 'tpath_bs/uploadreport';
    private testCancelUrl = webapi + 'tpath_bs/testcancel/';
    private unitByStaffId = webapi + 'mst_staff/byunitbystaffid/';
    private labDashboard = webapi + 'tpath_bs/labdashboard/';
    private GetByPatientIdRecordService = webapi + 'tpath_bs/get_by_patientid/?';
    private pendingReportCount = webapi + 'tpath_bs/pendingreportcount/';
    private pendingTestReportCount = webapi + 'tpath_bs/pendingreportcountnew/';
    private labSubGroupList = webapi + 'mbill_sub_group/listbygroup/';
    private GetLastTestReportParam = webapi + 'mpath_result/listoflastpathreport/?';
    private getdetailreportPrint = webapi + 'tpath_bs/labreport';
    private getshortreportPrint = webapi + 'tpath_bs/labshort';
    private TestHistoryByPatientIdTestId = webapi + 'tpath_bs/prevtesthistory/';
    private TestHistoryByPatientId = webapi + 'tpath_bs/prevtesttophistory/';
    private testTemplates = webapi + 'testTemplate/getTestTemplate/';

  constructor(private http: Http) {
  }

    getAllTestTemplate(templateId: any): Promise<any> {
        return this.http.get(this.testTemplates +  templateId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

  getLabDashboard(json: any): Observable<any> {
    return this.http.put(this.labDashboard, JSON.stringify(json), {headers: this.headers})
      .map(response => response.json())
      .pipe(
        tap(
          error => this.logError(error)
        ));
  }

  getPendingReportCount(json: any): Observable<any> {
    return this.http.put(this.pendingReportCount, JSON.stringify(json), {headers: this.headers})
      .map(response => response.json())
      .pipe(
        tap(
          error => this.logError(error)
        ));
  }
 getPendingTestReportCount(json: any): Observable<any> {
    return this.http.put(this.pendingTestReportCount, JSON.stringify(json), {headers: this.headers})
      .map(response => response.json())
      .pipe(
        tap(
          error => this.logError(error)
        ));
  }

  getAllServiceRecordService(currentPage: any, size: any, jsonString: any, sort: any, col: any): Observable<any> {
    // console.log('hello :', currentPage, size, jsonString, sort, col);
    return this.http.put(this.listAllnew + currentPage + '/' + size + '/' + sort + '/' + col, JSON.stringify(jsonString), {headers: this.headers})
      .map(response => response.json())
      .pipe(
        tap(
          error => this.logError(error)
        ));
  }

  getAllRecordByUnitIdService(unitId: any): Observable<any> {
    return this.http.get(this.ListRecordByUnitId + 'unitId=' + unitId)
        .map(response => response.json())
        .pipe(
            tap(
                error => this.logError(error)
            ));
  }
  /*getAllRecordByIPDChargeId(ipdchargeId: any) {
    return this.http.get(this.ListRecordByIpdChargeId + 'ipdchargeId=' + ipdchargeId)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }*/

  getReportedTestByPsId(currentPage: any, size: any, qString: any, psId: any, sort: any, col: any): Observable<any> {
    return this.http.get(this.listReportedTestBypsId + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&psId=' + psId + '&sort=' + sort + '&col=' + col)
        .map(response => response.json())
        .pipe(
            tap(
                error => this.logError(error)
            ));
      /* .toPromise()
      .then(response => response.json())
      .catch(this.handleError);*/
  }

  addLoAcceptance(model: any) {
    return this.http.post(this.addLabOrderAcceptanceurl, JSON.stringify(model), {headers: this.headers})
       /* .map(response => response.json())
        .pipe(
            tap(
                error => this.logError(error)
            ));*/
       .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  addTestAcceptance(model: any): Observable<any> {
    return this.http.post(this.addTestAcceptanceUrl, JSON.stringify(model), {headers: this.headers})
        .map(response => response.json())
        .pipe(
            tap(
                error => this.logError(error)
            ));
      /* .toPromise()
      .then(response => response.json())
      .catch(this.handleError);*/
  }

  // vijay
  getAllTestRecordService(currentPage: any, size: any, qString: any, billId: any, isIPD: any, sort: any, col: any): Observable<any> {
    return this.http.get(this.listTestOrder + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&billId=' + billId + '&isIPD=' + isIPD + '&sort=' + sort + '&col=' + col)
      .map(response => response.json())
      .pipe(
        tap(
          error => this.logError(error)
        ));
  }

    getAllTestRecordServiceByBillId(currentPage: any, size: any, qString: any, billId: any, isIPD: any, sort: any, col: any): Observable<any> {
        return this.http.get(this.listTestOrderByBillId + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&billId=' + billId + '&isIPD=' + isIPD + '&sort=' + sort + '&col=' + col)
            .map(response => response.json())
            .pipe(
                tap(
                    error => this.logError(error)
                ));
    }



  addCollectedSample(model: any): Observable<any> {
    return this.http.post(this.addCollectedSampleurl, JSON.stringify(model), {headers: this.headers})
        .map(response => response.json())
        .pipe(
            tap(
                error => this.logError(error)
            ));
      /*  .toPromise()
      .then(response => response.json())
      .catch(this.handleError);*/
  }

  addCollectedSample_SSPM(model: any): Observable<any> {
    return this.http.post(this.addCollectedSampleurl_sspm, JSON.stringify(model), {headers: this.headers})
        .map(response => response.json())
        .pipe(
            tap(
                error => this.logError(error)
            ));
      /*  .toPromise()
      .then(response => response.json())
      .catch(this.handleError);*/
  }

  addAcceptSample(model: any): Observable<any> {
    return this.http.post(this.addAcceptedSampleurl, JSON.stringify(model), {headers: this.headers})
        .map(response => response.json())
        .pipe(
            tap(
                error => this.logError(error)
            ));
      /*.toPromise()
      .then(response => response.json())
      .catch(this.handleError);*/
  }
    addacceptedsampleList (model: any): Observable<any> {
    return this.http.post(this.AddacceptedsampleList , JSON.stringify(model), {headers: this.headers})
        .map(response => response.json())
        .pipe(
            tap(
                error => this.logError(error)
            ));
      /*.toPromise()
      .then(response => response.json())
      .catch(this.handleError);*/
  }

  addRejectSample(model: any): Observable<any> {
    return this.http.post(this.addRejectedSampleurl, JSON.stringify(model), {headers: this.headers})
        .map(response => response.json())
        .pipe(
            tap(
                error => this.logError(error)
            ));
      /* .toPromise()
      .then(response => response.json())
      .catch(this.handleError);*/
  }

  addResultEntry(model: any): Observable<any> {
    return this.http.post(this.addResultEntryurl, JSON.stringify(model), {headers: this.headers})
        .map(response => response.json())
        .pipe(
            tap(
                error => this.logError(error)
            ));
      /* .toPromise()
      .then(response => response.json())
      .catch(this.handleError);*/
  }

// vijay
  getTestSamplesList(currentPage: any, size: any, qString: any, testId: any, billId: any, sort: any, col: any): Observable<any> {
    return this.http.get(this.listTestSamples + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&testId=' + testId + '&billId=' + billId + '&sort=' + sort + '&col=' + col)
        .map(response => response.json())
        .pipe(
            tap(
                error => this.logError(error)
            ));
      /* .toPromise()
      .then(response => response.json())
      .catch(this.handleError);*/
  }

  addRecordService(model: any) {
    return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
        /*.map(response => response.json())
        .pipe(
            tap(
                error => this.logError(error)
            ));*/
       .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }
 editRecordService(model: any) {
    return this.http.post(this.EditTest, JSON.stringify(model), {headers: this.headers})
      /*  .map(response => response.json())
        .pipe(
            tap(
                error => this.logError(error)
            ));*/
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }
editTestStatuService(model: any) {
    return this.http.post(this.EditTestStatus, JSON.stringify(model), {headers: this.headers})
       /* .map(response => response.json())
        .pipe(
            tap(
                error => this.logError(error)
            ));*/
     .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  deleteRecordService(id: any) {
    return this.http.put(this.DeleteRecord + id, {headers: this.headers})
        /*.map(response => response.json())
        .pipe(
            tap(
                error => this.logError(error)
            ));*/
         .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordService(id: any) {
    return this.http.get(this.GetRecord + id)
      /*  .map(response => response.json())
        .pipe(
            tap(
                error => this.logError(error)
            ));*/
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getStaffByUserId(userId: any): Observable<any> {
    return this.http.get(this.getStaffIdByUserId + '&userid=' + userId)
        .map(response => response.json())
        .pipe(
            tap(
                error => this.logError(error)
            ));
      /*.toPromise()
      .then(response => response.json())
      .catch(this.handleError);*/
  }

  getTestIdByMbillServiceId(mBillServiceId: any): Observable<any> {
    return this.http.get(this.testIdByMbillServiceId + mBillServiceId)
        .map(response => response.json())
        .pipe(
            tap(
                error => this.logError(error)
            ));
      /* .toPromise()
      .then(response => response.json())
      .catch(this.handleError);*/
  }

  getRecordByTrId(currentPage: any, size: any, qString: any, trId: any, sort: any, col: any): Observable<any> {
    return this.http.get(this.GetTestReportParam + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&trId=' + trId + '&sort=' + sort + '&col=' + col)
        .map(response => response.json())
        .pipe(
            tap(
                error => this.logError(error)
            ));
      /*  .toPromise()
      .then(response => response.json())
      .catch(this.handleError);*/
  }

    getLastRecordByTrId(currentPage: any, size: any, qString: any, trId: any, sort: any, col: any): Observable<any> {
        return this.http.get(this.GetLastTestReportParam + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&trId=' + trId + '&sort=' + sort + '&col=' + col)
            .map(response => response.json())
            .pipe(
                tap(
                    error => this.logError(error)
                ));
        /*  .toPromise()
            .then(response => response.json())
            .catch(this.handleError);*/
    }

  deleteTestReportByTrId(trId: any) {
    return this.http.put(this.deleteTestReportByTrIdUrl + trId, {headers: this.headers})
      /*  .map(response => response.json())
        .pipe(
            tap(
                error => this.logError(error)
            ));*/
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordTestParameterService(currentPage: any, size: any, qString: any, testId: any, sort: any, col: any): Observable<any> {
    return this.http.get(this.listParamByTestId + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&testId=' + testId + '&sort=' + sort + '&col=' + col)
        .map(response => response.json())
        .pipe(
            tap(
                error => this.logError(error)
            ));
      /* .toPromise()
      .then(response => response.json())
      .catch(this.handleError);*/
  }

  reduceItemFromInventory(model: any): Observable<any> {
    return this.http.post(this.reduceItemQtyUrl, JSON.stringify(model), {headers: this.headers})
        .map(response => response.json())
        .pipe(
            tap(
                error => this.logError(error)
            ));
      /*.toPromise()
      .then(response => response.json())
      .catch(this.handleError);*/
  }

  findItemByTestId(id: any): Observable<any> {
    return this.http.get(this.searchItemByTestId + id)
        .map(response => response.json())
        .pipe(
            tap(
                error => this.logError(error)
            ));
      /* .toPromise()
      .then(response => response.json())
      .catch(this.handleError);*/
  }

  findTestIdByServiceId(id: any): Observable<any> {
    return this.http.get(this.searchTestIdByServiceId + id)
        .map(response => response.json())
        .pipe(
            tap(
                error => this.logError(error)
            ));
      /* .toPromise()
      .then(response => response.json())
      .catch(this.handleError);*/
  }

  addUploadReport(model: any): Observable <any> {
    return this.http.post(this.addUploadReporturl, JSON.stringify(model), {headers: this.headers})
        .map(response => response.json())
        .pipe(
            tap(
                error => this.logError(error)
            ));
      /* .toPromise()
      .then(response => response.json())
      .catch(this.handleError);*/
  }

  sendSmsOnSampleColletion(model: any): Observable<any> {
    return this.http.post(this.smsOnSampleColletionUrl, JSON.stringify(model), {headers: this.headers})
        .map(response => response.json())
        .pipe(
            tap(
                error => this.logError(error)
            ));
      /*.toPromise()
      .then(response => response.toString())
      .catch(this.handleError);*/
  }

  sendSmsOnReportFinalized(model: any): Observable<any> {
    return this.http.post(this.smsOnReportFinalizedUrl, JSON.stringify(model), {headers: this.headers})
        .map(response => response.json())
        .pipe(
            tap(
                error => this.logError(error)
            ));
      /*.toPromise()
      .then(response => response.toString())
      .catch(this.handleError);*/
  }

  onTestCancel(model: any): Observable<any> {
    return this.http.post(this.testCancelUrl, JSON.stringify(model), {headers: this.headers})
        .map(response => response.json())
        .pipe(
            tap(
                error => this.logError(error)
            ));
      /*  .toPromise()
      .then(response => response.json())
      .catch(this.handleError);*/
  }

  // vijay
  getUnitsByStaffId(id: any): Observable<any> {
    return this.http.get(this.unitByStaffId + id)
        .map(response => response.json())
        .pipe(
            tap(
                error => this.logError(error)
            ));
      /* .toPromise()
      .then(response => response.json())
      .catch(this.handleError);*/
  }

    getLabSubGroupList(id: any): Observable<any> {
        return this.http.get(this.labSubGroupList + id)
            .map(response => response.json())
            .pipe(
                tap(
                    error => this.logError(error)
                ));
        /* .toPromise()
            .then(response => response.json())
            .catch(this.handleError);*/
    }

    getDetailedReportPrint() {
        return this.http.post(this.getdetailreportPrint, {headers: this.headers})
           /* .map(response => response.json())
            .pipe(
                tap(
                    error => this.logError(error)
                ));*/
         .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getShortReportPrint() {
        return this.http.post(this.getshortreportPrint, {headers: this.headers})
           /* .map(response => response.json())
            .pipe(
                tap(
                    error => this.logError(error)
                ));*/
          .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

  // EMR dignosis view
  getByPatientIdRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Observable<any> {
    return this.http.get(this.GetByPatientIdRecordService + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
        .map(response => response.json())
        .pipe(
            tap(
                error => this.logError(error)
            ));
      /* .toPromise()
      .then(response => response.json())
      .catch(this.handleError);*/
  }
    getTestHistoryByPatientIdAndTestIdService(patientvisitId: any, testId: any): Observable<any> {
        return this.http.get(this.TestHistoryByPatientIdTestId + patientvisitId + '/' + testId)
            .map(response => response.json())
            .pipe(
                tap(
                    error => this.logError(error)
                ));

        /* .toPromise()
            .then(response => response.json())
            .catch(this.handleError);*/
    }
    getTestHistoryByPatientIdService(patientvisitId: any): Observable<any> {
        return this.http.get(this.TestHistoryByPatientId + patientvisitId)
            .map(response => response.json())
            .pipe(
                tap(
                    error => this.logError(error)
                ));

        /* .toPromise()
            .then(response => response.json())
            .catch(this.handleError);*/
    }

  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }

  private logError(error: Response | any) {
    return Observable.throw(error.message || error);
  }

  print(d){
      console.log(d);
  }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/investigation/pathology/lab_order_list/lab_order_list.service.ts